import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

import { PAGE_ANCHOR_QUERY_PARAM } from '@/constants/pageAnchor';
import { usePageAnchors } from '@/contexts/pageAnchorsContext';

/**
 * Jumps to one of the open page's cards and records it in the url, so the address bar is a link
 * straight to that card. The history entry is replaced rather than pushed: hopping between cards
 * should not fill the back button with stops on the same page.
 */
const usePageAnchorJump = () => {
  const { scrollToAnchor } = usePageAnchors();
  const [, setSearchParams] = useSearchParams();

  return useCallback(
    (id: string) => {
      scrollToAnchor(id);
      setSearchParams(
        (current) => {
          const next = new URLSearchParams(current);
          next.set(PAGE_ANCHOR_QUERY_PARAM, id);

          return next;
        },
        { replace: true }
      );
    },
    [scrollToAnchor, setSearchParams]
  );
};

export default usePageAnchorJump;
